import { render, staticRenderFns } from "./Vitrines.vue?vue&type=template&id=9c66f4c4&scoped=true"
import script from "./Vitrines.vue?vue&type=script&lang=js"
export * from "./Vitrines.vue?vue&type=script&lang=js"
import style0 from "./Vitrines.vue?vue&type=style&index=0&id=9c66f4c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c66f4c4",
  null
  
)

export default component.exports